import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const FREE_PATHS = ["/dashboard/track", "/dashboard/help", "/dashboard/applications"];
const SIDE_PATHS = {
  universities: ["/dashboard/marks", "/dashboard/courses", "/dashboard/apply/", "/dashboard/apply-batch", "/dashboard/study"],
  colleges: ["/dashboard/colleges", "/dashboard/apply-college", "/dashboard/study"],
  nsfas: ["/dashboard/nsfas"],
};
const SIDE_HOME = { universities: "/dashboard/marks", colleges: "/dashboard/colleges", nsfas: "/dashboard/nsfas" };
const isSidePath = (p) => Object.values(SIDE_PATHS).flat().some((x) => p === x || (x.endsWith("/") && p.startsWith(x)));
const allowedOnSide = (side, p) => (SIDE_PATHS[side] || []).some((x) => p === x || (x.endsWith("/") && p.startsWith(x)));

export const markSideChosen = () => localStorage.setItem("yva_side_chosen", localStorage.getItem("yva_token") || "1");
const sideChosen = () => {
  const v = localStorage.getItem("yva_side_chosen");
  return !!v && v === (localStorage.getItem("yva_token") || "1");
};

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
        <Loader2 className="w-8 h-8 animate-spin text-[#0B2447]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  const isStudent = !user.role || user.role === "student";
  const needsSide = !sideChosen() || !["universities", "colleges", "nsfas"].includes(user.track);
  const p = location.pathname;
  if (isStudent && needsSide && !FREE_PATHS.includes(p)) return <Navigate to="/dashboard/track" replace />;
  if (isStudent && isSidePath(p) && !allowedOnSide(user.track, p)) return <Navigate to={SIDE_HOME[user.track] || "/dashboard/track"} replace />;
  return children;
}
